import Sarafrika from './components/Sarafrika';
import Header from './components/Header';
import Page2 from './components/Page2'
import Events from './components/Events';
import Shop from './components/Shop';
import Nimeahidi from './components/Nimeahidi';
import Eneza from './components/Eneza';
import BFF from './components/Bff';
import Elimika from './components/Elimika';
import Terms from './components/Terms';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import { Footer, Products } from './containers';
import { Products } from './containers';
const App = () => (
  <Router>
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={(
            <>
              <div className="gradient__bg">
                <Header />
              </div>
              <Sarafrika />
              {/* <Page2 /> */}
            </>
          )}
        />
        <Route path="/products" element={<Products />} />
        <Route path="/elimika" element={<Elimika />} />
        <Route path="/bff" element={<BFF />} />
        <Route path="/eneza" element={<Eneza />} />
        <Route path="/nimeahidi" element={<Nimeahidi />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/events" element={<Events />} />
        <Route path="/privacy" element={<Terms />} />

      </Routes>
      <Footer />
    </div>
  </Router>
);

export default App;
